import React from 'react';
import { DMRVPageTemplate } from '../components/dmrv/DMRVPageTemplate';
export function EUDRDueDiligence() {
  return <DMRVPageTemplate id="eudr" tagline="EUDR Due Diligence | Uganda & East Africa" headline="EU Deforestation Regulation Due Diligence for African Exporters" highlightWord="EU Deforestation Regulation" description="Uganda's coffee, cocoa, timber, and agricultural exporters must prove their goods are deforestation-free before entering the EU. CarbonSafe automates EUDR due diligence statements, geolocation mapping, and supply chain traceability from farm to port." badges={['EUDR Compliant', 'GPS Verified', 'Farm-Level Traceability', 'Deforestation-Free']} heroEmoji="🌿" floatingIcons={[{
    emoji: '🛰️',
    position: 'top'
  }, {
    emoji: '📍',
    position: 'right'
  }, {
    emoji: '🌳',
    position: 'left'
  }]} stats={[{
    value: '$900M+',
    label: 'Uganda Coffee Exports',
    detail: 'Annual coffee exports to the EU at risk without EUDR compliance'
  }, {
    value: '1.7M+',
    label: 'Smallholder Farmers',
    detail: 'Ugandan farmers whose livelihoods depend on EU market access'
  }, {
    value: 'Dec 2025',
    label: 'EUDR Enforcement',
    detail: 'EU enforcement deadline for large operators — SMEs follow in 2026'
  }, {
    value: '7',
    label: 'Regulated Commodities',
    detail: 'Coffee, cocoa, timber, palm oil, soy, cattle, rubber — and derived products'
  }]} statsHeadline="EUDR is reshaping Uganda's EU trade" statsSubtext="From December 2025, EU importers must verify that goods are deforestation-free and legally produced. Without farm-level traceability data, Ugandan exporters lose access." howItWorksVerticalName="EUDR due diligence" howItWorksSubtext="From farm GPS coordinates to verified due diligence statements — four steps to EUDR-compliant EU market access." howItWorksSteps={[{
    icon: 'MapPinIcon',
    title: 'Farm Geolocation',
    description: 'Collect GPS polygon coordinates for every farm plot in your supply chain via mobile app or USSD. No smartphone required for farmers.'
  }, {
    icon: 'ScanLineIcon',
    title: 'Deforestation Risk Assessment',
    description: 'Cross-reference farm coordinates against satellite forest cover data, protected area maps, and EU country benchmarking classifications.'
  }, {
    icon: 'ShieldCheckIcon',
    title: 'Due Diligence Statement',
    description: 'Auto-generate EUDR-compliant due diligence statements with full traceability documentation for each shipment to the EU.'
  }, {
    icon: 'GlobeIcon',
    title: 'EU Registry Submission',
    description: 'Submit due diligence statements directly to the EU EUDR Information System (EUDR IS) and provide reference numbers to EU importers.'
  }]} impactTagline="Who Needs EUDR Compliance" impactHeadline="Every Ugandan exporter selling to the EU" impactDescription="The EUDR applies to any operator or trader placing regulated commodities on the EU market. Ugandan coffee exporters, timber companies, and agro-processors must provide verified due diligence statements or face import bans, fines up to 4% of EU turnover, and reputational damage with European buyers." impactCtaText="Check Your EUDR Exposure" impactImageUrl="https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=800&h=600&fit=crop&crop=center" impactImageAlt="Coffee farmer in Uganda with mobile phone for EUDR traceability" featuresHeadline="Complete EUDR due diligence," featuresHighlight="farm to port" featuresSubtext="CarbonSafe handles every step of the EUDR compliance workflow — from collecting farm GPS data in remote areas to submitting verified statements to EU authorities." features={[{
    icon: 'MapPinIcon',
    title: 'Farm-Level GPS Mapping',
    description: 'Collect precise GPS polygon coordinates for every farm plot via USSD on any phone or mobile app. Works offline in remote growing regions across Uganda.'
  }, {
    icon: 'ScanLineIcon',
    title: 'Satellite Deforestation Checks',
    description: 'Automated cross-referencing of farm coordinates against global forest watch data, Uganda Forest Authority maps, and EU deforestation risk benchmarks.'
  }, {
    icon: 'ShieldCheckIcon',
    title: 'EUDR Due Diligence Statements',
    description: 'Auto-generate legally compliant due diligence statements for each shipment. Includes all required information: geolocation, quantity, country of origin, and risk assessment.'
  }, {
    icon: 'GlobeIcon',
    title: 'EU EUDR IS Integration',
    description: 'Direct submission to the EU EUDR Information System. Generate reference numbers for EU importers and maintain a full submission history for audits.'
  }, {
    icon: 'UsersIcon',
    title: 'Cooperative & Exporter Portals',
    description: 'Separate portals for farmer cooperatives, exporters, and EU importers. Each party sees only what they need — with full data integrity maintained throughout.'
  }, {
    icon: 'BarChart3Icon',
    title: 'Supply Chain Risk Dashboard',
    description: "Real-time visibility into your supply chain's EUDR risk profile. Flag high-risk plots, track remediation, and monitor compliance status across all suppliers."
  }]} ctaHeadline="Don't lose your EU buyers." ctaHighlight="Get EUDR compliant before enforcement." ctaSubtext="Uganda's coffee and agricultural exporters have months, not years. CarbonSafe delivers farm-level traceability and verified due diligence statements at scale." ctaButtonText="Start EUDR Due Diligence" data-id="element-1979" />;
}